import {
  Checkbox,
  ClickAwayListener,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
} from '@material-ui/core';
import React, { useRef } from 'react';
import { _without } from 'underscore-es';

import { useToggle } from '../../libs/react-use-extra';
import { Button } from './ContactStatusFilter.styled';

const STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'archived', label: 'Archived' },
];

const labelFor = value => {
  if (value.length === 0) return 'None';
  if (value.length === STATUSES.length) return 'All';
  return STATUSES.filter(s => value.includes(s.value))
    .map(s => s.label)
    .join(', ');
};

const ContactStatusFilter = ({ value, onChange }) => {
  const buttonRef = useRef();
  const [isOpen, { on: open, off: close }] = useToggle();

  const isChecked = status => value.includes(status);

  const notifyToggle = status => {
    const newValue = value.includes(status)
      ? _without(value, status)
      : [...value, status];
    onChange(newValue);
  };

  return (
    <>
      <Button ref={buttonRef} onClick={open}>
        {labelFor(value)}
      </Button>
      <Popper
        open={isOpen}
        anchorEl={buttonRef.current}
        placement="bottom-start"
        style={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={close}>
          <Paper elevation={3}>
            <List dense disablePadding>
              {STATUSES.map(({ value: statusValue, label }) => (
                <ListItem
                  key={statusValue}
                  dense
                  button
                  onClick={() => notifyToggle(statusValue)}
                >
                  <ListItemIcon style={{ minWidth: 0 }}>
                    <Checkbox
                      size="small"
                      edge="start"
                      color="primary"
                      checked={isChecked(statusValue)}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText primary={label} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default ContactStatusFilter;
